/**
 * Potluck Routes
 * Admin back-office for volunteer sign-up sheets (list + builder/detail).
 * The public sign-up page is registered separately in auth.routes.tsx.
 */

import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { AppShell } from "@/components/layout/AppShell";
import { LazyPage } from "../helpers";

const PotlucksListPage = lazy(() => import("@/pages/potlucks/PotlucksListPage"));
const PotluckDetailPage = lazy(
  () => import("@/pages/potlucks/PotluckDetailPage"),
);

const MANAGER_ROLES = ["super_user", "admin", "principal"];

export const potluckRoutes: RouteObject[] = [
  {
    path: "/potlucks",
    element: (
      <ProtectedRoute roles={MANAGER_ROLES}>
        <AppShell>
          <LazyPage>
            <PotlucksListPage />
          </LazyPage>
        </AppShell>
      </ProtectedRoute>
    ),
  },
  {
    path: "/potlucks/:id",
    element: (
      <ProtectedRoute roles={MANAGER_ROLES}>
        <AppShell>
          <LazyPage>
            <PotluckDetailPage />
          </LazyPage>
        </AppShell>
      </ProtectedRoute>
    ),
  },
];
